import { normalize } from 'normalizr';
import { arrayOfChannels } from 'shared/schemas';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';


const ACTIONS = createAsyncActions('SERVER.CHANNELS.SEARCH');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (query, options) {

  options = {
    ...options,
    paging: { size: 1000 },
  };

  return function (dispatch) {
    dispatch(START());

    return vodAdapter.lists.search(query, options)
      .then(
        function (response) {
          response = {
            ...response,
            data: normalize(response.data, arrayOfChannels),
          };

          dispatch(SUCCESS({}, response));
          return response;
        },

        function (response) {
          dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'shared.channels.search' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channels/search.js